export const valores = [
  {
    title: "Lealtad",
    content: `Entidad respetuosa y comprometida con
    la comunidad en proporcionar los
    servicios necesarios para salvar vidas y
    proteger bienes. `,
    color: "white",
    imagen:"/img/icons/valores/lealtad.jpg",
    width:80
  },
  {
    title: "Honradez",
    content: `Respetar y hacer buen uso de los
    recursos de la institución y de la
    ciudadanía. `,
    color: "white",
    imagen:"/img/icons/valores/honradez.png",
    width:36
  },
  {
    title: "Valentía",
    content: `Enfrentar los riesgos con acciones que
    permitan el fiel cumplimiento de la misión
    institucional en beneficio de la población
    afectada. `,
    color: "white",
    imagen:"/img/icons/valores/valentia.png",
    width:50
  },
  {
    title: "Disciplina",
    content: `Realizar las labores de forma ordenada y
    con responsabilidad dando cumplimiento
    de las actividades designadas en cada
    proceso institucional`,
    color: "white",
    imagen:"/img/icons/valores/disciplina.png",
    width:50
  },
  {
    title: "Trabajo en Equipo",
    content: `Cumplir con los objetivos planteados de
    forma coordinada e integrada.`,
    color: "white",
    imagen:"/img/icons/valores/trabajo-en-equipo.png",
    width:36
  },
  {
    title: "Solidaridad",
    content: `Brindar la ayuda necesaria y
    desinteresada a la comunidad. `,
    color: "white",
    imagen:"/img/icons/valores/solidaridad.png",
    width:32
  },
  {
    title: "Abnegación",
    content: `Renuncia de los intereses personales al
    beneficio e interés de la comunidad. `,
    color: "white",
    imagen:"/img/icons/valores/abnegacion.png",
    width:40
  },
  {
    title: "Respeto",
    content: `Consideración con las actitudes y
    pensamientos de los compañeros y la
    comunidad.`,
    color: "white",
    imagen:"/img/icons/valores/respeto.jpg",
    width:50
  },
  {
    title: "Compromiso",
    content: `Convicción personal en torno a los
    beneficios que trae el desempeño
    responsable de las tareas a su cargo para
    el cumplimiento de la misión y visión
    institucional.`,
    color: "white",
    imagen:"/img/icons/valores/compromiso.png",
    width:50
  },
  {
    title: "Carácter voluntario",
    content: `Involucra a la comunidad en los servicios
    que brinda el Cuerpo de Bomberos,
    logrando la integridad y colaboración de
    los habitantes del cantón.`,
    color: "white",
    imagen:"/img/icons/valores/caracter-voluntario.png",
    width:50
  },
];
